<template>
  <div>
    <v-runtime-template :template="includeTemplate"/>
  </div>
</template>

<script>
import '/static/css/guide.css'
import VRuntimeTemplate from 'v-runtime-template'
import wepHtmlToString from '@/plugins/_common/WepHtmlToString'
import { isEmpty } from 'lodash'

export default {
  name: 'MobGuide',
  components: {
    VRuntimeTemplate
  },
  data () {
    return {
      includeHtml: ''
    }
  },
  computed: {
    includeTemplate () {
      return this.includeHtml
    }
  },
  async created () {
    if (isEmpty(wepHtmlToString.mainTemplate)) {
      this.getEmptyTemplate('wepMobGuide.html')
    } else {
      this.includeHtml = wepHtmlToString.mainTemplate
    }
  },
  methods: {
    getEmptyTemplate (resourceUrl) {
      resourceUrl = this.getTemplatePath(resourceUrl)
      this.$http.loadRes(resourceUrl).then( (res) => {
        wepHtmlToString.mainTemplate = res
        this.includeHtml = wepHtmlToString.mainTemplate
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/contents/guide/MobGuide.vue